import React, { useEffect } from 'react'
import './Privacy_Policy.css'
import Green_Btn from '../common_components/common_btn/green_btn/Green_Btn'
import Light_Gray_Btn from '../common_components/common_btn/light_gray_btn/Light_Gray_Btn'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getPrivacy_Policy } from '../../features/privacypolicy/Slice';
import Breadcrumb_comp from '../common_components/breadcrumb-comp/Breadcrumb_comp';
import parse from "html-react-parser"

const Privacy_Policy = () => {
    const navigate = useNavigate()
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "PRIVACY POLICY", link: "", isActive: true },
    ];

    const privacyPolicy = useSelector((state) => state.privacypolicy.privacypolicy)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getPrivacy_Policy());

    }, [])
    console.log("jvfj", privacyPolicy);


    return (

        <>
            <section className='Privacy_Policy'>
                <div className='bg_img_div'>
                    <div className='bg_div'>
                        {/* <img src='/assets/images/privacy/bg2.png' className='bg_img' /> */}
                    </div>
                    <div className='white_bg_div'>
                        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                        <div className='container'>
                            <p className='section_title'>Privacy Policy</p>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='main_content_div'>
                        {privacyPolicy?.data?.map((pp) => (<p className='dark_black_text'>{parse(pp.content)}</p>))}

                    </div>
                </div>
            </section>
            {/* <Stay_Connected /> */}
        </>



    )
}

export default Privacy_Policy
